import { Icon } from 'palette/Icon';
import { BodyText, Small, TextHighlighter } from 'palette/Typography';
import { BEMBlock } from '@helpers/classnames';
import type { GlobalSearchResultsData } from '../types';
import GlobalSearchHeader from './GlobalSearchHeader';
import GlobalSearchResultsBlock from './GlobalSearchResultsBlock';
import GlobalSearchRow from './GlobalSearchRow';
import '../styles/GlobalSearchSuggestions.scss';

interface GlobalSearchSuggestionsProps {
    searchTerm: string;
    searchResults: GlobalSearchResultsData;
    onSearchSuggestionClick: (navigationId: number) => void;
}

function GlobalSearchSuggestions({
    searchResults, searchTerm, onSearchSuggestionClick,
}: GlobalSearchSuggestionsProps) {
    const [block, BEMElement] = BEMBlock('global-search-suggestions');

    return (
        <div className={block}>
            {searchResults?.groups?.map(({ title: sectionTitle, items }) => (
                <GlobalSearchResultsBlock key={sectionTitle}>
                    <GlobalSearchHeader title={sectionTitle} />
                    {items.map(({
                        title, navigation_id: navigationId, breadcrumbs, url,
                    }, index) => (
                        <GlobalSearchRow
                            // eslint-disable-next-line react/no-array-index-key
                            key={index}
                            href={url}
                            onClick={() => onSearchSuggestionClick(navigationId)}
                        >
                            <div className={BEMElement('item')}>
                                <TextHighlighter
                                    color="strong"
                                    isRegex={false}
                                    value={searchTerm}
                                    weight="bold"
                                >
                                    <BodyText
                                        level="1"
                                        transform="none"
                                    >
                                        {title}
                                    </BodyText>
                                </TextHighlighter>
                                <Small color="light">{breadcrumbs}</Small>
                            </div>
                            <Icon
                                className={BEMElement('icon')}
                                color="grey-800"
                                name="palette_chevron_right"
                                size="small"
                            />
                        </GlobalSearchRow>
                    ))}
                </GlobalSearchResultsBlock>
            ))}
        </div>
    );
}

export default GlobalSearchSuggestions;
